import { Map } from "@/components/map"

export const MapRoute = () => {

    return (
        <div className="absolute inset-0 z-0">
            <Map />
        </div>
    )
}